import { Box, Button, CircularProgress, Grid, MenuItem, TextField, Typography } from "@material-ui/core";
import { enumMaxWidth, enumPaisMexCode } from "../../settings/enumConfig";
import { inputColor, inputVariant } from "../../settings/inputConfig";

import { Autocomplete } from "@material-ui/lab";
import { Fragment } from "react";
import ProveedoresTitle from "../layout/ProveedoresTitle";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { useDatosCompania } from "../../context/DatosCompaniaContext";
import { useDomicioFiscal } from "../../context/DomicilioFiscalContext";

const DomicilioFiscal = () => {
    const {
        listaPaises,
        listaEstados,
        listaMunicipios,
        listaCiudades,
        listaColonias,
        domicilioFiscalForm,
        handleChangeDomicilioFiscalForm,
        handleChangeDomicilioFiscalFormNotError,
        handleClickRegresar,
        handleClickSiguiente,
        handleChangeEstado,
        handleChangeMunicipio,
        handleBlurCodigoPostal,
        handleChangePaisSeleccionado,
        paisMexicoValidacion,
    } = useDomicioFiscal();
    const { datosCompaniaEnt } = useDatosCompania();

    const {
        txtCalle,
        txtCiudad,
        txtCodigoPostal,
        txtColonia,
        txtOtraColonia,
        txtEstado,
        txtMunicipio,
        txtNumeroExterior,
        txtNumeroInterior,
        txtPais,
    } = domicilioFiscalForm;

    // useEffect(() => {
    //     handleChangLoadEvalPais();
    //     // eslint-disable-next-line
    // }, []);

    return (
        <Fragment>
            <Grid container spacing={4} className="content-over">
                <Grid item xs={12}>
                    <Box style={{ borderRadius: "15px", maxWidth: enumMaxWidth, margin: "auto" }}>
                        <Grid container spacing={4}>
                            {listaPaises.length === 0 || listaEstados.length === 0 ? (
                                <Grid item xs={12} className="center">
                                    <CircularProgress />
                                    <Typography>Cargando formulario...</Typography>
                                </Grid>
                            ) : (
                                <Fragment>
                                    <Grid item xs={12}>
                                        <ProveedoresTitle>Domicilio fiscal de la compañía</ProveedoresTitle>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Grid container spacing={4}>
                                            {datosCompaniaEnt && (
                                                <Grid item xs={12}>
                                                    <Autocomplete
                                                        options={listaPaises}
                                                        getOptionDisabled={(option) =>
                                                            option.sCodigoPais === enumPaisMexCode && !paisMexicoValidacion
                                                        }
                                                        getOptionLabel={(option) => (!option.sPais ? "" : option.sPais)}
                                                        fullWidth
                                                        value={txtPais.value}
                                                        onChange={handleChangePaisSeleccionado}
                                                        disablePortal={true}
                                                        disabled={paisMexicoValidacion}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label={txtPais.label}
                                                                variant={inputVariant}
                                                                color={inputColor}
                                                                error={txtPais.required && txtPais.error}
                                                                helperText={txtPais.required && txtPais.error && txtPais.helper}
                                                            />
                                                        )}
                                                        renderOption={(option, { inputValue }) =>
                                                            parse(option.sPais, match(option.sPais, inputValue)).map((part, index) => (
                                                                <span key={index} className={part.highlight ? "highlight" : ""}>
                                                                    {part.text}
                                                                </span>
                                                            ))
                                                        }
                                                    />
                                                </Grid>
                                            )}
                                            <Grid item xs={12}>
                                                <TextField
                                                    name={txtCodigoPostal.name}
                                                    label={txtCodigoPostal.label}
                                                    required={txtCodigoPostal.required && paisMexicoValidacion}
                                                    value={txtCodigoPostal.value}
                                                    error={txtCodigoPostal.required && txtCodigoPostal.error}
                                                    helperText={txtCodigoPostal.required && txtCodigoPostal.error && txtCodigoPostal.helper}
                                                    onChange={
                                                        !paisMexicoValidacion
                                                            ? handleChangeDomicilioFiscalFormNotError
                                                            : handleChangeDomicilioFiscalForm
                                                    }
                                                    onBlur={!paisMexicoValidacion ? () => {} : handleBlurCodigoPostal}
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 20,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                {paisMexicoValidacion ? (
                                                    <TextField
                                                        name={txtEstado.name}
                                                        label={txtEstado.label}
                                                        required={txtEstado.required}
                                                        value={txtEstado.value}
                                                        error={txtEstado.required && txtEstado.error}
                                                        helperText={txtEstado.required && txtEstado.error && txtEstado.helper}
                                                        onChange={handleChangeEstado}
                                                        variant={inputVariant}
                                                        color={inputColor}
                                                        fullWidth
                                                        select
                                                        SelectProps={{
                                                            MenuProps: {
                                                                anchorOrigin: {
                                                                    vertical: "bottom",
                                                                    horizontal: "left",
                                                                },
                                                                getContentAnchorEl: null,
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value="">-- Seleccione estado --</MenuItem>
                                                        {listaEstados.map((x) => (
                                                            <MenuItem key={x.sEstado} value={x.sEstado}>
                                                                {x.sEstado}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                ) : (
                                                    <TextField
                                                        name={txtEstado.name}
                                                        label={txtEstado.label}
                                                        value={txtEstado.value}
                                                        error={txtEstado.required && txtEstado.error}
                                                        helperText={txtEstado.required && txtEstado.error && txtEstado.helper}
                                                        onChange={
                                                            !paisMexicoValidacion
                                                                ? handleChangeDomicilioFiscalFormNotError
                                                                : handleChangeDomicilioFiscalForm
                                                        }
                                                        variant={inputVariant}
                                                        color={inputColor}
                                                        fullWidth
                                                        inputProps={{
                                                            maxLength: 250,
                                                        }}
                                                    />
                                                )}
                                            </Grid>
                                            <Grid item xs={12}>
                                                {paisMexicoValidacion ? (
                                                    <TextField
                                                        name={txtMunicipio.name}
                                                        label={txtMunicipio.label}
                                                        required={txtMunicipio.required}
                                                        value={txtMunicipio.value}
                                                        error={txtMunicipio.required && txtMunicipio.error}
                                                        helperText={txtMunicipio.required && txtMunicipio.error && txtMunicipio.helper}
                                                        onChange={handleChangeMunicipio}
                                                        variant={inputVariant}
                                                        color={inputColor}
                                                        fullWidth
                                                        select
                                                        SelectProps={{
                                                            MenuProps: {
                                                                anchorOrigin: {
                                                                    vertical: "bottom",
                                                                    horizontal: "left",
                                                                },
                                                                getContentAnchorEl: null,
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value="">-- Seleccione municipio --</MenuItem>
                                                        {listaMunicipios.map((x) => (
                                                            <MenuItem key={x.sMunicipio} value={x.sMunicipio}>
                                                                {x.sMunicipio}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                ) : (
                                                    <TextField
                                                        name={txtMunicipio.name}
                                                        label={txtMunicipio.label}
                                                        value={txtMunicipio.value}
                                                        error={txtMunicipio.required && txtMunicipio.error}
                                                        helperText={txtMunicipio.required && txtMunicipio.error && txtMunicipio.helper}
                                                        onChange={
                                                            !paisMexicoValidacion
                                                                ? handleChangeDomicilioFiscalFormNotError
                                                                : handleChangeDomicilioFiscalForm
                                                        }
                                                        variant={inputVariant}
                                                        color={inputColor}
                                                        fullWidth
                                                        inputProps={{
                                                            maxLength: 250,
                                                        }}
                                                    />
                                                )}
                                            </Grid>
                                            <Grid item xs={12}>
                                                {paisMexicoValidacion && listaCiudades.length > 0 ? (
                                                    <TextField
                                                        name={txtCiudad.name}
                                                        label={txtCiudad.label}
                                                        required={txtCiudad.required}
                                                        value={txtCiudad.value}
                                                        error={txtCiudad.required && txtCiudad.error}
                                                        helperText={txtCiudad.required && txtCiudad.error && txtCiudad.helper}
                                                        onChange={handleChangeDomicilioFiscalForm}
                                                        variant={inputVariant}
                                                        color={inputColor}
                                                        fullWidth
                                                        select
                                                        SelectProps={{
                                                            MenuProps: {
                                                                anchorOrigin: {
                                                                    vertical: "bottom",
                                                                    horizontal: "left",
                                                                },
                                                                getContentAnchorEl: null,
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value="">-- Seleccione ciudad --</MenuItem>
                                                        {listaCiudades.map((x) => (
                                                            <MenuItem key={x.sCiudad} value={x.sCiudad}>
                                                                {x.sCiudad}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                ) : (
                                                    <TextField
                                                        name={txtCiudad.name}
                                                        label={txtCiudad.label}
                                                        value={txtCiudad.value}
                                                        error={txtCiudad.required && txtCiudad.error}
                                                        helperText={txtCiudad.required && txtCiudad.error && txtCiudad.helper}
                                                        onChange={
                                                            !paisMexicoValidacion
                                                                ? handleChangeDomicilioFiscalFormNotError
                                                                : handleChangeDomicilioFiscalForm
                                                        }
                                                        variant={inputVariant}
                                                        color={inputColor}
                                                        fullWidth
                                                        inputProps={{
                                                            maxLength: 250,
                                                        }}
                                                    />
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Grid container spacing={4}>
                                            {paisMexicoValidacion && listaColonias.length > 0 ? (
                                                <Fragment>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            name={txtColonia.name}
                                                            label={txtColonia.label}
                                                            required={txtColonia.required}
                                                            value={txtColonia.value}
                                                            error={txtColonia.required && txtColonia.error}
                                                            helperText={txtColonia.required && txtColonia.error && txtColonia.helper}
                                                            onChange={handleChangeDomicilioFiscalForm}
                                                            variant={inputVariant}
                                                            color={inputColor}
                                                            fullWidth
                                                            select
                                                            SelectProps={{
                                                                MenuProps: {
                                                                    anchorOrigin: {
                                                                        vertical: "bottom",
                                                                        horizontal: "left",
                                                                    },
                                                                    getContentAnchorEl: null,
                                                                },
                                                            }}
                                                        >
                                                            <MenuItem value="">-- Seleccione colonia --</MenuItem>
                                                            {listaColonias.map((x) => (
                                                                <MenuItem key={x.sColonia} value={x.sColonia}>
                                                                    {x.sColonia}
                                                                </MenuItem>
                                                            ))}
                                                            <MenuItem value="#OTRA#">OTRA</MenuItem>
                                                        </TextField>
                                                    </Grid>
                                                    {txtColonia.value === "#OTRA#" && (
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                name={txtOtraColonia.name}
                                                                label={txtOtraColonia.label}
                                                                required={txtOtraColonia.required}
                                                                value={txtOtraColonia.value}
                                                                error={txtOtraColonia.required && txtOtraColonia.error}
                                                                helperText={
                                                                    txtOtraColonia.required && txtOtraColonia.error && txtOtraColonia.helper
                                                                }
                                                                onChange={
                                                                    !paisMexicoValidacion
                                                                        ? handleChangeDomicilioFiscalFormNotError
                                                                        : handleChangeDomicilioFiscalForm
                                                                }
                                                                variant={inputVariant}
                                                                color={inputColor}
                                                                fullWidth
                                                                inputProps={{
                                                                    maxLength: 200,
                                                                }}
                                                            />
                                                        </Grid>
                                                    )}
                                                </Fragment>
                                            ) : (
                                                <Grid item xs={12}>
                                                    <TextField
                                                        name={txtColonia.name}
                                                        label={txtColonia.label}
                                                        value={txtColonia.value}
                                                        error={txtColonia.required && txtColonia.error}
                                                        helperText={txtColonia.required && txtColonia.error && txtColonia.helper}
                                                        onChange={
                                                            !paisMexicoValidacion
                                                                ? handleChangeDomicilioFiscalFormNotError
                                                                : handleChangeDomicilioFiscalForm
                                                        }
                                                        variant={inputVariant}
                                                        color={inputColor}
                                                        fullWidth
                                                        inputProps={{
                                                            maxLength: 200,
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                            <Grid item xs={12}>
                                                <TextField
                                                    name={txtCalle.name}
                                                    label={txtCalle.label}
                                                    required={txtCalle.required && paisMexicoValidacion}
                                                    value={txtCalle.value}
                                                    error={txtCalle.required && txtCalle.error}
                                                    helperText={txtCalle.required && txtCalle.error && txtCalle.helper}
                                                    onChange={
                                                        !paisMexicoValidacion
                                                            ? handleChangeDomicilioFiscalFormNotError
                                                            : handleChangeDomicilioFiscalForm
                                                    }
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 150,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    name={txtNumeroExterior.name}
                                                    label={txtNumeroExterior.label}
                                                    required={txtNumeroExterior.required}
                                                    value={txtNumeroExterior.value}
                                                    error={txtNumeroExterior.required && txtNumeroExterior.error}
                                                    helperText={
                                                        txtNumeroExterior.required && txtNumeroExterior.error && txtNumeroExterior.helper
                                                    }
                                                    onChange={handleChangeDomicilioFiscalForm}
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 10,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    name={txtNumeroInterior.name}
                                                    label={txtNumeroInterior.label}
                                                    required={txtNumeroInterior.required}
                                                    value={txtNumeroInterior.value}
                                                    error={txtNumeroInterior.required && txtNumeroInterior.error}
                                                    helperText={
                                                        txtNumeroInterior.required && txtNumeroInterior.error && txtNumeroInterior.helper
                                                    }
                                                    onChange={
                                                        !paisMexicoValidacion
                                                            ? handleChangeDomicilioFiscalFormNotError
                                                            : handleChangeDomicilioFiscalForm
                                                    }
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 10,
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Fragment>
                            )}
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <div className="form-buttons">
                        <Button variant="contained" color="secondary" onClick={handleClickRegresar}>
                            Regresar
                        </Button>
                        <Button variant="contained" color="primary" style={{ marginLeft: 10 }} onClick={handleClickSiguiente}>
                            Siguiente
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default DomicilioFiscal;
